import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";

export function ReportFailedDialogComponent({open= false, handlingClose = null, failedReport=null, setFailedReport= null}){

    if(!failedReport && !setFailedReport){
        return;
    }

    return(
        <Dialog fullWidth open={open} onClose={handlingClose} aria-describedby="alert-dialog-slide-description">
            <DialogTitle>{"Escribe el reporte o falla de la unidad"}</DialogTitle>
            <DialogContent>
                <TextField multiline fullWidth
                           value={!!failedReport.text? failedReport.text:""}
                           onChange={(event)=>setFailedReport(old=>{return{...old, text: event.target.value }})}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setFailedReport({text: null, status:false })}>Limpiar</Button>
                <Button onClick={handlingClose}>Cancelar</Button>
                <Button onClick={ () => setFailedReport(old=>{return{...old, status:false }})}>Agregar</Button>
            </DialogActions>
        </Dialog>
    );
}